import { PLATFORM_ERROR_HANDLERS } from '@platform-frontend/platform';
import { HandleErrorsGlobalRecord, ShowErrorNotification } from '@platform-frontend/util';
import { MSG_ACCOUNT_INACTIVE_TOKEN, MSG_ACCOUNT_INVALID_TOKEN } from './notification-messages';
import { SignOutOnError } from './session/session.actions';

export const ACCOUNT_ERROR_HANDLERS: HandleErrorsGlobalRecord = {
  ...PLATFORM_ERROR_HANDLERS,
  INVALID_TOKEN: new SignOutOnError(new ShowErrorNotification(MSG_ACCOUNT_INVALID_TOKEN)),
  INACTIVE_TOKEN: new SignOutOnError(new ShowErrorNotification(MSG_ACCOUNT_INACTIVE_TOKEN)),
};
